exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".linked-document-id_text{font-size:11px;font-weight:500;line-height:normal}", ""]);

// exports
